import React, { Component } from 'react';

export default class DemoFrame extends Component {

    constructor(props) {
        super(props);

        this.state = {

        }
    }

    render() {

        let frameJsx = null;

        if (this.props.active) {
            frameJsx = (
                <iframe className={"demo-frame"} src='https://www.appdemostore.com/embed?id=5665985557168128' frameborder='0'></iframe>
            );
        }

        return (
            <div className={"demo-outer" + (this.props.active ? " active" : "")}>
                <div className={"demo-shadow"} onClick={this.props.demoOff}></div>
                {frameJsx}
                <div className={"demo-exit"} onClick={this.props.demoOff}>{"Exit"}</div>
            </div>
        );
    }
}
